<template>
  <table class="table table-hover table-responsive align-middle">
    <thead>
      <tr>
        <th>Joueur</th>
        <th>Poste</th>
        <th>Note</th>
        <th>Bonus</th>
        <th>Final</th>
      </tr>
    </thead>
    <tbody>
      <template v-for="(player, index) in players" :key="player.playerId">
        <player-display :player="player" :player-index="index" />
        <tr v-if="needAverageRow(index)" class="average-row">
          <td class="average-row__label" colspan="4">
            {{ getPositionLabel(player.getEffectivePosition()) }}
          </td>
          <td class="average-row__final">
            {{ roundFloat(positionAverages[player.getEffectivePosition()]) }}
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script setup>
import PlayerDisplay from "@/components/player/PlayerDisplay.vue";
import { calculatePositionsAverages } from "@/utils/averages/averageCalculator";
import { roundFloat } from "@/utils/math/math";
import { computed } from "vue";

const props = defineProps({
  players: {
    type: Array,
    required: true,
  },
});

const POSITION_BACKER = 2;
const POSITION_MIDDLE = 3;
const POSITION_FORWARD = 4;

const positionAverages = computed(() => {
  const pitchPlayers = Array.isArray(props.players) ? props.players : [];
  if (! pitchPlayers.length) {
    return {
      [POSITION_BACKER]: 0,
      [POSITION_MIDDLE]: 0,
      [POSITION_FORWARD]: 0,
    };
  }
  const arr = calculatePositionsAverages({ pitchPlayers });
  return {
    [POSITION_BACKER]: arr?.[1] ?? 0,
    [POSITION_MIDDLE]: arr?.[2] ?? 0,
    [POSITION_FORWARD]: arr?.[3] ?? 0,
  };
});

const isLineWithAverage = (position) => [POSITION_BACKER, POSITION_MIDDLE, POSITION_FORWARD].includes(position);

const isEndOfPosition = (index) => {
  const current = props.players[index];
  if (! current || ! isLineWithAverage(current.getEffectivePosition())) {
    return false;
  }
  const next = props.players[index + 1];
  return ! next || next.getEffectivePosition() !== current.getEffectivePosition();
};

const needAverageRow = (index) => {
  const current = props.players[index];
  return current && isEndOfPosition(index) && isLineWithAverage(current.getEffectivePosition());
};

const getPositionLabel = (position) => {
  switch (position) {
  case POSITION_BACKER:
    return "Moyenne de la défense";
  case POSITION_MIDDLE:
    return "Moyenne du milieu";
  case POSITION_FORWARD:
    return "Moyenne de l'attaque";
  default:
    return "";
  }
};
</script>

<style lang="scss" scoped>
  th {
    font-weight: bold;
    text-align: left;
    padding: 0 5px;
  }

  .average-row {
    td {
      font-size: 0.8em;
      font-weight: 500;
    }
    &__label {
      text-align: right;
    }
  }
</style>